"use client";

import React, { forwardRef } from "react";
import { ErrorMessage } from "@hookform/error-message";
import camelCase from "just-camel-case";
import { FieldErrors, FieldValues } from "react-hook-form";

import { VALIDATIONS } from "@app/constants";
import { cn, onBlurWorkaround, renderErrorMessage } from "@app/utils";

import { createVariants } from "../constants";

interface FieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode;
  errors: FieldErrors<FieldValues>;
  requiredLabel?: boolean;
}

export const Field = forwardRef<HTMLInputElement, FieldProps>((props, ref) => {
  const { label, errors, ...inputProps } = props;
  let id: string = inputProps.id;
  if (inputProps.id === undefined) {
    if (inputProps.name !== undefined) {
      id = inputProps.name;
    } else if (typeof label === "string") {
      id = camelCase(label);
    } else {
      throw new Error("Field must have an id, name, or string label");
    }
  }
  return (
    <>
      <label
        htmlFor={id}
        className={cn(createVariants.label.base, {
          'after:text-color-error after:content-["_*"]': props.requiredLabel,
        })}
      >
        {label}
      </label>
      <input 
        type="text" 
        id={id} 
        className={createVariants.input.base} 
        {...inputProps} 
        ref={ref}
        onBlur={onBlurWorkaround}
      />
      <ErrorMessage errors={errors} name={id} render={renderErrorMessage} />
    </>
  );
});

Field.displayName = "Field";
